import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

export const FormWrapper = styled.form`
  & .MuiFormControl-root {
    margin-bottom: 16px;

    @media (min-width: ${getBreakpoint('md')}px) {
      margin-bottom: 24px;
    }
  }

  & .dynamic-text-block-wrapper {
    display: flex;
    align-items: center;
    height: 100%;
    p {
      margin: 0 0 16px;
      font-family: Lato;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 19px;
      color: #41414a;
      align-self: center;
      @media (min-width: ${getBreakpoint('xl')}px) {
        margin-top: -16px;
      }
    }
  }
`

export const ButtonWrapper = styled.section`
  margin-top: 24px;
  margin-bottom: 48px;
`
